import type { Token, TokenSnapshot } from "../types";

/** Strip non-serializable imageEl from a Token before sending over WS or storing in undo. */
export function serializeToken(token: Token): TokenSnapshot {
  const { imageEl, ...rest } = token;
  return rest;
}
